module.exports = __webpack_public_path__ + "img/zhou4.3416dd78.png";